import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { UserServiceClient } from 'fitbeat.api-clients';
import { SignupFlowType } from 'fitbeat.gym-core';
import { AccountType, RemoteConfigVariables } from 'fitbeat.models';
import {
  Button,
  ButtonTypes,
  ButtonSize,
} from 'fitbeat.react-native-components';
import { StyleSheet, View } from 'react-native';
import { getUrls } from '../config';
import { GoogleAnalytics } from '../services/google-analytics';
import { getApiConfig } from '../config/index';
import { getSignupFlowScreens } from './actions';
import Theme from '../theme';
import { defaultScale } from '../utils/scaling';
import { WelcomeImageSlider } from './WelcomeImageSlider';
import { RemoteConfigWrapper } from '../ui/components/RemoteConfigWrapper';
import { openLink } from '../utils/linkUtils';

class WelcomeMobileWeb extends Component {
  googleAnalytics = new GoogleAnalytics();

  constructor(props) {
    super(props);
    this.googleAnalytics.setCurrentScreen('Welcome', 'Welcome');
    this.props.getSignupFlowScreens(SignupFlowType.TypeOne);
  }

  componentDidUpdate = async (prevProps) => {
    const { wasDeepLink, continueSignupToken } = this.props;
    const shouldNavigate =
      (continueSignupToken && prevProps.continueSignupToken !== continueSignupToken) ||
      (wasDeepLink && prevProps.wasDeepLink !== wasDeepLink);
    if (shouldNavigate) {
      this.handleNavigateToAuthScreen();
    }
  };

  handleNavigateToAuthScreen = () => {
    const { wasDeepLink, continueSignupToken, accountType, workoutInviteId, invitationCode } = this.props;
    if (wasDeepLink) {
      if (invitationCode) {
        this.props.navigation.navigate('InvitationCodeSignup');
        return;
      }
      if (accountType === AccountType.Home) {
        this.props.navigation.navigate('login');
      }
    }
  };

  login = () => {
    this.props.navigation.navigate('Login');
  };

  seeMembershipPlans = () => {
    const { MEMBERSHIP_PLANS } = getUrls();
    openLink(MEMBERSHIP_PLANS);
  };

  render() {
    const { t } = this.props;

    return (
      <div className={'full-height hide-scroll-bar'}>
        <View style={styles.container}>
          <WelcomeImageSlider t={t} />
          <View style={styles.footer}>
            <Button
              onPress={this.login}
              title={t('loginTo')}
              buttonType={ButtonTypes.OUTLINE}
              size={ButtonSize.MEDIUM}
            />
          </View>
        </View>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: '100%',
    backgroundColor: Theme.WHITE,
  },
  footer: {
    padding: defaultScale(15),
  },
});

const mapStateToProps = (state) => {
  const { wasDeepLink, continueSignupToken, accountType, workoutInviteId, invitationCode } = state.deepLinkParamaters;

  return {
    accountType,
    wasDeepLink,
    workoutInviteId,
    continueSignupToken,
    invitationCode,
  };
};

const mapDispatchToProps = (dispatch) => {
  const userProfileService = new UserServiceClient(getApiConfig(), fetch, console.log, undefined);
  return {
    getSignupFlowScreens: (signupFlowType) =>
      dispatch(getSignupFlowScreens(userProfileService, signupFlowType)),
  };
};

WelcomeMobileWeb = connect(mapStateToProps, mapDispatchToProps)(WelcomeMobileWeb);
export default translate(['auth'], { wait: true })(WelcomeMobileWeb);
